import { UpsellAdMetadataProto } from "@noom/noom-contracts/noom_contracts/offers/upsell_ad/api/upsell_ad_service";
import { getAuthorizationHeader } from "src/api/utils";
import { appConfig } from "src/config";

export async function fetchUpsellAdMetadata(
  upsellAdIdentifier: string
): Promise<UpsellAdMetadataProto | null> {
  const response = await fetch(
    `${appConfig.OFFERS_API_URL}/upsell/v1/adMetadata/${encodeURIComponent(
      upsellAdIdentifier
    )}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthorizationHeader(),
      },
    }
  );

  if (!response.ok) return null;
  return response.json();
}
